import { Component, OnChanges, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { NavigationService } from '@services/navigation.service';

@Component({
    standalone: false,
    selector: 'ingsv-adm-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnChanges, OnInit {
  @Input() width = '100%';
  @Input() number = 0;
  @Input() currentPage = 0;
  @Input() paginationMaxNumber = 20;
  @Input() paginationMiddleNumber = 2;
  @Input() allowToGoNext = true;

  @Output() stepChanged = new EventEmitter<any>();

  steps = [];

  constructor(
    private navigationService: NavigationService
  ) {}

  ngOnInit() {
    if (!this.navigationService.getSearchData().page) {
      this.navigationService.setUrlFilterData('page', this.currentPage + '');
    }
  }

  ngOnChanges(changes: any) {
    if (this.number) {
      this.steps = [];
      for (let i = 0; i < this.number; i++) {
        this.steps.push(i + 1);
      }
    }
  }

  setStep(step) {
    if (step !== this.currentPage + 1) {
      this.currentPage = step - 1;
      this.stepChanged.emit(this.currentPage);
      this.navigationService.setUrlFilterData('page', this.currentPage + '');
    }
  }

  hidePaginationItem(stepNumberToShow, currentPage): boolean {
    if (Math.abs(currentPage - stepNumberToShow) > this.paginationMiddleNumber) {
      return true;
    } else {
      return false;
    }
  }

  goToPrev() {
    if (this.currentPage !== 0) {
      this.currentPage = this.currentPage - 1;
      this.stepChanged.emit(this.currentPage);
      this.navigationService.setUrlFilterData('page', this.currentPage + '');
    }
  }

  goToNext() {
    if (this.currentPage + 1 < this.steps.length && this.allowToGoNext) {
      this.currentPage = this.currentPage + 1;
      this.stepChanged.emit(this.currentPage);
      this.navigationService.setUrlFilterData('page', this.currentPage + '');
    }
  }
}
